export default class Notify {
	constructor() {

	}

	_defaultConfig(type) {
		return {
			'type': type,
			'allow_dismiss': true,
			'newest_on_top': false,
			'mouse_over': false,
			'showProgressbar': false,
			'spacing': '10',
			'timer': '2000',
			'placement': {
				'from': 'top',
				'align': 'right'
			},
			'offset': {
				'x': '30',
				'y': '30'
			},
			'delay': '1000',
			'z_index': '10000',
			'animate': {
				'enter': 'animated bounce',
				'exit': 'animated bounce'
			}
		}
	}

	notify(message, type) {
		const notify = $.notify({
			message: message
		}, this._defaultConfig(type))
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/classes/notify.js